<template>
  <div class="bg-t-dark- p-4 side-menu-main-wrapper">
    <b-row>
      <b-col class="text-center">
        <img class="side-logo" src="img/logo/timpel.png">
      </b-col>
    </b-row>
    <MenuItems/>
  </div>
</template>

<script>
import MenuItems from "@/components/base/MenuItems.vue"

export default {
  components:{
    MenuItems
  }
}
</script>

<style lang="scss">
  .side-logo{
    width: 200px;
    border-radius: 8px;
    padding: 5px;
  }
  .side-menu-item{
    cursor: pointer;
    height: 62px;
    span{
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      letter-spacing: 0.005em;
      text-align: left;
      svg{
        margin-top: -5px;
        path{
          fill: white;
          stroke: transparent;
        }
      }
    }
  }
  .side-menu-item:hover{
    color: #4395D1;
    background: #1B2635 !important;
    svg{
      margin-top: -5px;
      path{
        fill: #4395D1;
        stroke: transparent;
      }
    }
  }
  .side-menu-item.active{
    color: #4395D1;
    background: #1B2635 !important;
    svg{
      margin-top: -5px;
      path{
        fill: #4395D1;
        stroke: transparent;
      }
    }
  }
  .side-menu-main-wrapper{
    border-radius: 20px;
  }
</style>